import React from 'react';
import { Badge } from 'react-bootstrap';
import { getLevelInfo, getProjectName } from '../assets/logMetadata.js';

const LevelBadge = ({ value }) => {
  const info = getLevelInfo(value);
  return <Badge bg={info.badge} className="text-uppercase" style={{ fontSize: '0.7rem' }}>{info.label}</Badge>;
};

const getCircleColor = (level) => {
  return 'bg-primary';
};

// Project 1 — flex-interativa-webapps-server (minigames.logs)
export const getEventLogsColumns01 = (SelectColumnFilter) => [
  {
    Header: 'Projeto',
    accessor: 'projectLabel',
    Filter: SelectColumnFilter,
    filter: 'equals',
    Cell: ({ value, row }) => <span>{value || getProjectName(row.original.projeto)}</span>,
  },
  {
    Header: 'ID',
    accessor: 'id',
    Cell: ({ value, row }) => {
      const isViewed = row.original.viewed === 1;
      const circleClass = isViewed ? null : getCircleColor(row.original.level);
      return (
        <div className="d-flex align-items-center">
          {!isViewed && <span className={`${circleClass} rounded-circle d-inline-block me-2`} style={{ width: '10px', height: '10px', flexShrink: 0 }}></span>}
          <span className="text-nowrap">{value}</span>
        </div>
      );
    },
  },
  {
    Header: 'Operação ID',
    accessor: 'operationId',
  },
  {
    Header: 'Origem',
    accessor: 'origem',
    Filter: SelectColumnFilter,
    filter: 'equals',
  },
  {
    Header: 'Tipo',
    accessor: 'level',
    Filter: SelectColumnFilter,
    renderFilterLabel: (val) => getLevelInfo(val)?.label || val,
    filter: 'equals',
    Cell: ({ row }) => <LevelBadge value={row.original.level} />,
  },
  {
    Header: 'Resumo do log',
    accessor: 'json',
  },
  {
    Header: 'Operação',
    accessor: 'type',
    Filter: SelectColumnFilter,
    filter: 'equals',
  },
  {
    Header: 'Visitante ID',
    accessor: 'visitante_id',
    Cell: ({ value }) => <span>{value}</span>,
  },
  {
    Header: 'E-mail',
    accessor: 'user_email',
  },
  {
    Header: 'Custom. ID',
    accessor: 'customizacao_id',
  },
  {
    Header: 'Data',
    accessor: 'data',
  },
  {
    Header: '',
    accessor: 'icons',
    disableSortBy: true,
    Filter: false,
  },
];

// Project 2 — flex-interativa-plataforma-eventos-server (plataforma_eventos.logs)
export const getEventLogsColumns02 = (SelectColumnFilter) => [
  {
    Header: 'Projeto',
    accessor: 'projectLabel',
    Filter: SelectColumnFilter,
    filter: 'equals',
    Cell: ({ value, row }) => <span>{value || getProjectName(row.original.projeto)}</span>,
  },
  {
    Header: 'ID',
    accessor: 'id',
    Cell: ({ value, row }) => {
      const isViewed = row.original.viewed === 1;
      const circleClass = isViewed ? null : getCircleColor(row.original.level);
      return (
        <div className="d-flex align-items-center">
          {!isViewed && <span className={`${circleClass} rounded-circle d-inline-block me-2`} style={{ width: '10px', height: '10px', flexShrink: 0 }}></span>}
          <span className="text-nowrap">{value}</span>
        </div>
      );
    },
  },
  {
    Header: 'Operação ID',
    accessor: 'operationId',
  },
  {
    Header: 'Origem',
    accessor: 'origem',
    Filter: SelectColumnFilter,
    filter: 'equals',
  },
  {
    Header: 'Tipo',
    accessor: 'level',
    Filter: SelectColumnFilter,
    renderFilterLabel: (val) => getLevelInfo(val)?.label || val,
    filter: 'equals',
    Cell: ({ row }) => <LevelBadge value={row.original.level} />,
  },
  {
    Header: 'Resumo do log',
    accessor: 'json',
  },
  {
    Header: 'Operação',
    accessor: 'type',
    Filter: SelectColumnFilter,
    filter: 'equals',
  },
  {
    Header: 'Usuário ID',
    accessor: 'user_id',
    Cell: ({ value }) => <span>{value}</span>,
  },
  {
    Header: 'E-mail',
    accessor: 'user_email',
  },
  {
    Header: 'Data',
    accessor: 'data',
  },
  {
    Header: '',
    accessor: 'icons',
    disableSortBy: true,
    Filter: false,
  },
];
